import React from "react";
import YouTube from "react-youtube";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

export default function VideoPlayer({ videoId, onEnded }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  console.log("VideoPlayer props:", { videoId, onEnded });

  return (
    <Box>
      <Box
        sx={{
          position: "relative",
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <video
          width="100%"
          height="auto"
          controls
          autoPlay
          controlsList="nodownload"
          onEnded={onEnded}
          style={{
            display: "block",
            width: "100%",
            maxHeight: "500px",
          }}
        >
          <source src={videoId} type="video/mp4" />
          Your browser does not support video playback.
        </video>
      </Box>

      <Typography
        sx={{
          mt: 2,
          fontWeight: 600,
          fontSize: 18,
          color: theme.palette.text.primary,
        }}
      >
        Course Title
      </Typography>
    </Box>
  );
}
